import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const GravityCrumbleAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number
) => {
  const blocks = 30;
  const t = timeSeconds;
  for (let i = 0; i < blocks; i++) {
    const ang = (i / blocks) * Math.PI * 2;
    const r = getRadiusAtAngle(ang, e, e.maxRadius);
    const bx = Math.cos(ang) * r;
    const by = Math.sin(ang) * r;
    const force = config.shatterForce ?? 50;
    const gravity = config.shatterGravity ?? 1200;
    const vx = Math.cos(ang) * force * t;
    const vy = Math.sin(ang) * force * t + gravity * t * t;
    const sz = 18 * (1 - progress);
    ctx.save(); ctx.translate(clampX(e.pos.x + bx + vx), clampY(e.pos.y + by + vy)); ctx.rotate(t * 8);
    ctx.fillRect(-sz / 2, -sz / 2, sz, sz); ctx.restore();
  }
};

registerBlastAnimation('GRAVITY_CRUMBLE', GravityCrumbleAnimation);
